export default "__VITE_ASSET__CkYffKci__"